import zh_CN from './zh_CN/APP_HOME.json'
import enUS from 'vant/es/locale/lang/en-US'
import Locale from 'vant/es/locale'
export default {
  name: 'APP_HOME',
  version: 4,
  zh_CN,
  project: 'app-home',
  effect: (lang) => {
    if (lang === 'en_US') {
      Locale.use('en-US', enUS)
    }
  }
}
